export default __webpack_public_path__ + "static/media/Adult_OHCA_COS_600x415_72dpi_optimized.bdae5377.jpg";